export default "__VITE_ASSET__DET2SQrh__"